var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row container-fluid" }, [
    _c("div", { staticClass: "col-sm-3 col-md-4 col-lg-3 mb-2 mb-md-0" }, [
      _c("div", { staticClass: "breadcrumb-wrapper" }, [
        _c("div", {}, [
          _c(
            "nav",
            {
              attrs: { "aria-label": "breadcrumb my-project-breadcrumb-item" }
            },
            [
              _c(
                "ol",
                { staticClass: "breadcrumb my-project-breadcrumb-item px-0" },
                [
                  _c("li", { staticClass: "breadcrumb-item" }, [
                    _c(
                      "a",
                      {
                        staticStyle: { "text-decoration": "none" },
                        attrs: { href: "/Account/MyProjects" }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$resourceString[
                                "account.SideBar.MyProjects.Title"
                              ]
                            ) +
                            "\n              "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "breadcrumb-item" }, [
                    _c("span", { staticClass: "project-name" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.projectDetails.boardDetails.title) +
                          "\n              "
                      )
                    ])
                  ])
                ]
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.userRole
      ? _c(
          "div",
          { staticClass: "col-sm-2 col-md-3 col-lg-2 mb-2 mt-3 edit-project" },
          [
            _c("span", { on: { click: _vm.editProject } }, [
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.editProjectIcon) }
              }),
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$resourceString["myProject.Project.EditPage.Title"]
                  ) +
                  "\n    "
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.userRole
      ? _c(
          "div",
          {
            staticClass: "col-sm-3 col-md-4 col-lg-4",
            staticStyle: { "text-align": "end" }
          },
          [
            this.projectDetails.boardDetails.sections.some(function(section) {
              return (
                section.title === "default" && section.contentItems.length != 0
              )
            }) &&
            this.projectDetails.boardDetails &&
              this.projectDetails.boardDetails.status != 1
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary mb-2 mb-md-0 ",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.handleShareProject($event)
                      }
                    }
                  },
                  [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.projectShareIcon) }
                    }),
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$resourceString[
                            "myProject.Project.ShareProject.Title"
                          ]
                        ) +
                        "\n    "
                    )
                  ]
                )
              : _vm._e()
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.userRole
      ? _c(
          "div",
          { staticClass: "col-sm-3 col-md-4 col-lg-3 header-add-button" },
          [
            _c("add-item-button", {
              attrs: {
                onClickHandler: _vm.onClickHandler,
                buttonText: _vm.buttonText
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }